module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C764"
  }, [_c('strong', [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_vm._v("Acknowledgments")])])]), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_c('p', {
    staticClass: "P51"
  }, [_vm._v("The conference organizers thank those who contributed to making the conference successful, especially Brett Maranjian and the other staff members at the National Bureau of Economic Research (NBER) conference department. The authors of the chapters, the discussants, and the inquisitive audience played the most essential role. Discussants for the conference sessions were Pirmin Fessler, William Gale, David Johnson, Maggie R. Jones, Bruce D. Meyer, Frédérique Savingnac, and Alexander Yuskavage. Katharine Abraham, director of the Conference on Research in Income and Wealth (CRIW), provided helpful guidance. The organizers are also grateful to Helena Fitz-Patrick at NBER and to the staff at the University of Chicago Press (UCP) for guiding the volume through the publication process, and to anonymous referees from the NBER and the UCP.")]), _vm._v(" "), _c('p', {
    staticClass: "P4"
  }, [_vm._v("The conference would not have been possible without generous financial support from the Stone Center on Socio-Economic Inequality at the CUNY Graduate Center, the Stone Wealth and Income Inequality Project at Brown University, Statistics of Income/Internal Revenue Service, Opportunity Insights, and the NBER.")]), _vm._v(" "), _c('p', {
    staticClass: "P4"
  }, [_vm._v("The conference was part of a commemoration of the 100th anniversary of the NBER. The CRIW was launched as an NBER initiative in 1935. NBER president and CEO James Poterba delivered at lunchtime talk at the conference, explaining how income distribution and the share of national income received by labor and capital were among the key issues that led to the founding of the NBER.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ac75959a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/08_Acknowledgments.vue
// module id = 78
// module chunks = 0